import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbProductTabApplications } from '../../../models'

export const MB_PRODUCT_TAB_APPLICATIONS_NORMALIZER = new InjectionToken<Converter<any, MbProductTabApplications[]>>('MbProductTabApplicationsListNormalizer')
